/**
 * Stable ids for document headings (card 2.2): `slug-hash`, e.g.
 * "scope-in-order-1k3f9a". The slug keeps the id readable in a copied link;
 * the short hash (FNV-1a over the text and its occurrence) keeps two headings
 * with the same text apart and stays the same across reloads as long as the
 * heading's text does. The outline rail (OutlineRail.js) links to these.
 */

/** Lower-case, letters/digits of every language, dashes; at most 48 chars. */
export function headingSlug(text) {
  const s = String(text || '')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48)
    .replace(/-+$/, '');
  return s || 'section';
}

function fnv(text) {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(36).slice(0, 6);
}

/**
 * Ids for a document's headings, in document order. `texts` is every
 * heading's text; the n-th repeat of the same text hashes differently.
 */
export function headingIds(texts) {
  const seen = new Map();
  return (texts || []).map((raw) => {
    const text = String(raw || '').trim();
    const n = seen.get(text) || 0;
    seen.set(text, n + 1);
    return `${headingSlug(text)}-${fnv(`${text}\u0000${n}`)}`;
  });
}
